'use client';
import { Component } from 'react';
import type { TrackingPayload } from '@mentimeter/http-clients';
import { trackUser } from '@api/tracking/client';

class Track extends Component<TrackingPayload> {
  override componentDidMount() {
    trackUser(this.props);
  }

  override componentDidUpdate() {
    trackUser(this.props);
  }

  override render() {
    return null;
  }
}
export default Track;
